<ng-container *transloco="let t">
  @if (tag) {
    <pxw-product-tag size="xs" class="product-tag" [tag]="tag.tag" [color]="tag.color" />
  }
  <a
    data-testid="product-item"
    [title]="name"
    class="product ui-item-link"
    [ngClass]="{
      inactive: withoutStock() || hidden,
    }"
    [routerLink]="(withoutStock() && !isAdminMode) || sortEnabled ? [] : detailRoute"
    [queryParams]="detailRouteQueryParams"
  >
    <figure>
      @if (image) {
        <pxw-image
          [src]="image"
          [alt]="name"
          [width]="100"
          [height]="100"
          [imageSize]="imageSize"
          [lazyLoad]="listIndex >= 0 ? listIndex > lazyLoadImageMinIndex : true"
          [priority]="listIndex === 0"
          objectFit="cover"
          loader="sm"
        />
      }

      @if (withoutStock()) {
        <div class="content-without-stock">
          {{ t('productList.withoutStock') }}
        </div>
      } @else if (!image) {
        <div class="content-without-image">
          {{ t('productList.withoutImage') }}
        </div>
      }
    </figure>

    <div class="body">
      <div class="text">
        @if (displaySku && sku) {
          <p class="product-sku">{{ sku }}</p>
        }
        <h2 class="product-name">
          @if (hidden) {
            <pxw-icon icon="eye-slash" size="xs" class="hidden"></pxw-icon>
          }
          @if (!isAvailable) {
            <pxw-icon icon="clock" size="xs" color="warning" class="not-available"></pxw-icon>
          }
          {{ name }}
        </h2>
        @if (isAdminMode && isExample()) {
          <pxw-tag size="xs" type="neutral">{{ t('productList.exampleTag') }}</pxw-tag>
        }
        @if (hasPurchaseRestrictions()) {
          <pxw-product-restriction-tags
            [product]="purchaseRestrictions()"
            [purchaseOptions]="purchaseOptions()"
            [compact]="true"
          />
        }
      </div>
      @if (presentationItems) {
        <pxw-product-list-item-price
          itemType="product-with-presentations"
          [price]="presentationMinimumPrice"
          [headlineDiscount]="headlineDiscount"
          [size]="size()"
        />
      } @else {
        <pxw-product-list-item-price
          itemType="product"
          [price]="price"
          [priceDiscount]="priceDiscount"
          [headlineDiscount]="headlineDiscount"
          [size]="size()"
        />
      }
    </div>
    @if (isAdminMode) {
      <div class="actions">
        @if (!sortEnabled) {
          <button
            name="edit"
            [attr.aria-label]="t('product.editProduct')"
            [ngClass]="{ 'edit-disabled': isUpdatingImages }"
            (click)="onClickEdit($event)"
          >
            <pxw-icon icon="edit"></pxw-icon>
          </button>
          <button
            name="delete"
            [attr.aria-label]="t('product.deleteProduct')"
            (click)="onClickDelete($event)"
          >
            <pxw-icon icon="trash-can"></pxw-icon>
          </button>
        }
        @if (sortEnabled) {
          <div class="move">
            <pxw-icon icon="cross-arrows" size="sm" color="black"></pxw-icon>
          </div>
        }
      </div>
    }
  </a>
</ng-container>
